import { render } from "./AddNoteCard.vue?vue&type=template&id=124a2263&scoped=true"
import script from "./AddNoteCard.vue?vue&type=script&lang=js"
export * from "./AddNoteCard.vue?vue&type=script&lang=js"

import "./AddNoteCard.vue?vue&type=style&index=0&id=124a2263&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124a2263"]])

export default __exports__